import axios from "axios";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Webcam from "react-webcam";
import Cookies from "universal-cookie";
import { baseURL } from "../../../Config";
import { UPLOAD_PATIENT_DOCUMENT } from "../../../Helper/ApiPath";
import { CANCEL, CAPTURE, RETAKE_IMAGE, ROLES, UPLOAD } from "../../../Helper/Constants";
import { unix } from "../../../Helper/Helper";
import { UPLOAD_IMAGE } from "../../../Helper/Messages";

const videoConstraints = {
    width: 220,
    height: 200,
    facingMode: "user",
};

function WebcamUpload(props) {
    let navigate = useNavigate();
    const cookies = new Cookies();

    let role = cookies.get("role");
    if (role) {
        role = cookies.get("role").roleId;
    }
    let adminRole = localStorage.getItem("adminRole");
    const [img, setImg] = useState("");

    const webcamRef = React.useRef(null);

    const capture = React.useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setImg(imageSrc);
    });

    const handleRetake = () => {
        setImg("");
    };

    let logToken = JSON.parse(localStorage.getItem("logToken"));

    const handleUpload = async () => {
        if (!img) {
            toast.error(UPLOAD_IMAGE);
        } else {
            await axios
                .post(`${baseURL}/${UPLOAD_PATIENT_DOCUMENT}`, {
                    headers: { authorization: logToken.token, "Content-Type": "multipart/form-data" },
                    fileName: props.popUpTitle + "_" + unix(new Date()) + ".png",
                    patientId: props.patientId,
                    type: props.imageType,
                    webCam: img,
                    isPreAuthorization: props.isPreAuthorization,
                    preAuthId: props.preAuthId,
                    statusId: props.statusId,
                    isDoctor: role == ROLES.DOCTOR || adminRole == ROLES.DOCTOR ? true : false,
                })
                .then((res) => {
                    props.fetchThumbnailData(props.imageType, props.patientId);
                    if (props.isPreAuthorization || (props.edit && props.preAuthId)) {
                        props.fetchData();
                    }
                    props.handleWebcameClose();
                    setImg("");
                    toast.success(res.data.message);
                })
                .catch((err) => {
                    if (err.response) {
                        if (err.response.status == 500) {
                            localStorage.clear();
                            navigate("/login");
                        } else {
                            toast.error(err.response.data.message);
                        }
                    }
                });
        }
    };

    return (
        <>
            <Modal show={props.webcame} onHide={props.handleWebcameClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{props.popUpTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="webcam-container">
                        <div className="webcam-img text-center">
                            {img == "" ? <Webcam audio={false} height={500} ref={webcamRef} screenshotFormat="image/jpeg" width={520} videoConstraints={videoConstraints} /> : <img src={img} />}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={props.handleWebcameClose}>
                        {CANCEL}
                    </Button>

                    <div>
                        {img != "" ? (
                            <>
                                <button onClick={handleRetake} className="webcam-btn btn btn-warning">
                                    {RETAKE_IMAGE}
                                </button>
                                <button className="btn btn-primary mx-2" onClick={handleUpload}>
                                    {UPLOAD}
                                </button>
                            </>
                        ) : (
                            <button onClick={capture} className="webcam-btn btn btn-warning">
                                {CAPTURE}
                            </button>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default WebcamUpload;
